import { some } from 'lodash';
import { z } from 'zod';

export const TablesSchema = z
  .object({
    restaurants: z
      .array(
        z
          .array(
            z.object({
              restaurant: z.object({
                configName: z.string(),
                restaurantName: z.string(),
                id: z.number(),
              }),
              adults: z.number(),
              children: z.number().optional(),
              visitDateRangeStart: z.string().optional(),
              visitDate: z.string(),
              timeslot: z.object({
                availablePromotions: z
                  .array(
                    z.object({
                      basePrice: z.number(),
                      feeAmount: z.number(),
                      id: z.string().or(z.number()),
                      leaveTime: z.string(),
                    })
                  )
                  .nullable(),
                hasStandardAvailability: z.boolean(),
                isLeaveTimeRequired: z.boolean().nullable(),
                leaveTime: z.string().nullable(),
                serviceId: z.number().nullable(),
                standardAvailabilityFeeAmount: z.number().nullable(),
                timeSlot: z.string(),
                timeslotReservationId: z.string().nullable().optional(),
              }),
              promotion: z.object({
                id: z.string().nullable(),
                name: z.string().nullable(),
                timeslotReservationId: z.string().nullable().optional(),
              }),
              hasDietaryRequirements: z.boolean().optional().default(false),
              dietaryRequirements: z.array(z.string()).optional(),
              hasCelebrationOptions: z.boolean().optional().default(false),
              celebrationOptions: z.array(z.string()).optional(),
            })
          )
          .optional()
      )
      .optional(),
    notes: z.string().optional(),
  })
  .optional()
  .superRefine((data, ctx) => {
    if (!data?.restaurants) return;

    data.restaurants.forEach((dayRestaurants, dayIndex) => {
      if (!dayRestaurants) return;

      dayRestaurants.forEach((restaurant, restaurantIndex) => {
        if (restaurant.hasDietaryRequirements && !some(restaurant.dietaryRequirements)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['restaurants', dayIndex, restaurantIndex, 'dietaryRequirements'],
          });
        }

        if (restaurant.hasCelebrationOptions && !some(restaurant.celebrationOptions)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['restaurants', dayIndex, restaurantIndex, 'celebrationOptions'],
          });
        }
      });
    });
  });

export type TablesFormValues = z.infer<typeof TablesSchema>;

export const PackageRestaurantSchema = z.object({
  delayAfter: z.number().optional(),
  id: z.string().optional(),
  menuIds: z.array(z.string()),
  restaurantId: z.string(),
  name: z.string().optional().nullable(),
  timeRestrictions: z
    .object({ startTime: z.string().length(8), endTime: z.string().length(8) })
    .nullable(),
  dayNumber: z.number(),
  dayNumberRange: z.array(z.number()),
});

export type PackageRestaurant = z.infer<typeof PackageRestaurantSchema>;

export type DiningOption = {
  id: number;
  menuIds: (string | number)[];
  timeslotRestrictions?: { startTime: string; endTime: string } | null;
  name?: string;
  delayAfter?: number;
  dayNumber: number;
};
